module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-36x36-dedffe8f13cb6d88cb7495f2803ceda5.png";